/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import Banner from '../banner/Banner';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.preview`;

export default class BannerPreview extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		this.active = new Stream(true); // TODO: remove debug value
	}

	view() {
		const { banner } = app.bannerFormState;

		return (
			<div className={`BannerPreview ${this.active() ? 'is-active' : ''} BannerPreview--${banner?.props()?.setup?.position}`}>
				<div className="container">
					<div className="BannerPreview-header">
						<div className="BannerPreview-header-toggle">
							<Button
								className="Button Button--icon"
								icon={this.active() ? 'fas fa-chevron-down' : 'fas fa-chevron-right'}
								onclick={() => this.active(!this.active())}
							/>
						</div>
						<div className="BannerPreview-header-title">{t(`${prfx}.title`)}</div>
					</div>
					{this.active() && (
						<div className="BannerPreview-content">
							<Banner banner={banner} />
						</div>
					)}
				</div>
			</div>
		);
	}
}
